import React from 'react';
import clsx from 'clsx';
import { Tab, Nav } from 'react-bootstrap';

import Container from '@common/Container';
import Section from '@common/Section';
import Heading from '@common/Heading';
import Row from '@common/Row';

import TabbedItem from '@common/blocks/list/tabs/TabbedItem';

import * as styles from '@styles/modules/block.module.scss';

const Tabs = ({ data }) => {
  const {
    title,
    showTitle,
    list,
    bgColour
  } = data;
  return (
    <Section className={clsx({[`bg-${bgColour} py-5`]: bgColour })}>
      <Container>
        {(showTitle && title) && <Heading type='h2' className='mx-auto mb-4 col-lg-10 text-center'>{title}</Heading>}
        <Row className='flex-column'>
          <div className={`d-none d-lg-block`}>
            <Tab.Container defaultActiveKey="0">
              <Nav variant={`tabs`} className={styles.tabbedMenuNavContainer}>
                {list.map((item, index) => (
                  <Nav.Item
                    className={clsx('h5 mb-0', styles.tabbedMenuNavItem)}
                    key={`n-${item.id}`}
                  >
                    <Nav.Link className={`border-0 h-100`} eventKey={index}>
                      {item.title}
                    </Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>
              <Tab.Content className={clsx('position-relative rounded-bottom shadow', styles.tabbedMenu)}>
                {list.map((item, index) => (
                  <Tab.Pane key={`p-${item.id}`} eventKey={index}>
                    <TabbedItem className={`py-4 px-3 pb-0`} data={item} />
                  </Tab.Pane>
                ))}
              </Tab.Content>
            </Tab.Container>
          </div>
          <div className='d-lg-none'>
            {list && list.map(item => (
              <TabbedItem key={`i-${item.id}`} data={item} />
            ))}
          </div>
        </Row>
      </Container>
    </Section>
  )
}

export default Tabs
